// Alfred dashboard — entry point. LOCKED: dashboard only renders for an
// authenticated Supabase session. No preview bypass.
import { supabase } from "./supabase";
import { renderAuth } from "./auth";
import { renderDashboard } from "./dashboard";

const app = document.querySelector<HTMLDivElement>("#app")!;

// Sweep stale preview-mode flag from older builds.
sessionStorage.removeItem("alfred.preview.user");

function renderLoader() {
  app.innerHTML = `<div class="loader">Loading Alfred...</div>`;
}

async function boot() {
  renderLoader();
  const { data } = await supabase.auth.getSession();
  if (data.session) {
    renderDashboard(app, data.session.user);
  } else {
    renderAuth(app, async () => {
      const { data: d2 } = await supabase.auth.getSession();
      if (d2.session) renderDashboard(app, d2.session.user);
    });
  }
}

boot();
